import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AdminDashboardComponent } from "./admin-dashboard/admin-dashboard.component";
import { AdminVendorsComponent } from "./admin-vendors/admin-vendors.component";
import { AdminDriversComponent } from "./admin-drivers/admin-drivers.component";
import { AdminDocumentsComponent } from "./admin-documents/admin-documents.component";
import { AdminGpsComponent } from "./admin-gps/admin-gps.component";
import { AdminLoadComponent } from "./admin-load/admin-load.component";
import { AdminProfileComponent } from "./admin-profile/admin-profile.component";
import { AdminTaxComponent } from "./admin-tax/admin-tax.component";
import { AdminTruckCategoryComponent } from "./admin-truck-category/admin-truck-category.component";
import { AdminTruckTypeComponent } from "./admin-truck-type/admin-truck-type.component";
import { AdminTrucksComponent } from "./admin-trucks/admin-trucks.component";
import { AdminTripsComponent } from "./admin-trips/admin-trips.component";
import { AdminPaymentsComponent } from "./admin-payments/admin-payments.component";
import { AdminInvoiceComponent } from './admin-invoice/admin-invoice.component';
import { AdminMappingComponent } from "./admin-mapping/admin-mapping.component";
import { AdminTrackComponent } from "./admin-track/admin-track.component";
import { AdminTrackNewComponent } from "./admin-track-new/admin-track-new.component";
import { AdminUsersComponent } from "./admin-users/admin-users.component";
import { AdminWebPagesComponent } from "./admin-web-pages/admin-web-pages.component";
import { AdminLoginComponent } from "./admin-login/admin-login.component";
import { AdminActivityLogComponent } from "./admin-activity-log/admin-activity-log.component";
import { ReportsComponent } from "../admin/Reports/reports.component";
import { AdminGpsTypeComponent } from "./admin-gps-type/admin-gps-type.component";
import { AdminWorkorderComponent } from "./admin-workorder/admin-workorder.component";
import { AdminDriverOrdersComponent } from "./admin-driver-orders/admin-driver-orders.component";
import { AdminPreOrdersComponent } from "./admin-pre-orders/admin-pre-orders.component";
import { AdminSettingsComponent } from "./admin-settings/admin-settings.component";
import { AdminPromotionalNotificationComponent } from "./admin-promotional-notification/admin-promotional-notification.component";

import { PermissionGuard } from "./permission.guard";

const routes: Routes = [
  {
    path: "admin",
    // component: AdminSidebarComponent,
    children: [
      {
        path: "dashboard",
        component: AdminDashboardComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "dashboard" }
      },
      {
        path: "vendors",
        component: AdminVendorsComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "vendors" }
      },
      {
        path: "trucks",
        component: AdminTrucksComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "trucks" }
      },
      {
        path: "loads",
        component: AdminLoadComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "loads" }
      },
      {
        path: "truck-category",
        component: AdminTruckCategoryComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "trucks" }
      },
      {
        path: "truck-type",
        component: AdminTruckTypeComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "trucks" }
      },
      {
        path: "drivers",
        component: AdminDriversComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "drivers" }
      },
      {
        path: "tax",
        component: AdminTaxComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "tax" }
      },
      {
        path: "gpsType",
        component: AdminGpsTypeComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "dashboard" } // Assuming dashboard can see this or add a new module id
      },
      {
        path: "gps",
        component: AdminGpsComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "dashboard" }
      },
      {
        path: "documents",
        component: AdminDocumentsComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "documents" }
      },
      {
        path: "trips",
        component: AdminTripsComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "trips" }
      },
      {
        path: "workorder",
        component: AdminWorkorderComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "workorder" }
      },
      {
        path: "payments",
        component: AdminPaymentsComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "payments" }
      },
      {
        path: "invoice",
        component: AdminInvoiceComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "invoice" }
      },
      {
        path: "mapping",
        component: AdminMappingComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "mapping" }
      },
      {
        path: "driverOrders",
        component: AdminDriverOrdersComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "driverOrders" }
      },
      {
        path: "track",
        component: AdminTrackComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "track" }
      },
      {
        path: "track-new",
        component: AdminTrackNewComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "track" }
      },
      {
        path: "users",
        component: AdminUsersComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "users" }
      },
      {
        path: "promotional-notifications",
        component: AdminPromotionalNotificationComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "promotional_notifications" }
      },
      {
        path: "webPages",
        component: AdminWebPagesComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "web" }
      },
      {
        path: "reports",
        component: ReportsComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "reports" }
      },
      {
        path: "login",
        component: AdminLoginComponent,
      },
      {
        path: "activity-log",
        component: AdminActivityLogComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "settings" }
      },
      {
        path: "pre-order",
        component: AdminPreOrdersComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "pre_orders" }
      },
      {
        path: "settings",
        component: AdminSettingsComponent,
        canActivate: [PermissionGuard],
        data: { moduleId: "settings" }
      },
    ],
  },
  {
    path: "adminprofile",
    component: AdminProfileComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule { }
